export default __webpack_public_path__ + "static/media/thank-you-teacher.d2417309.webp";